import React from 'react';
import ThemeHeader from '../ThemeHeader';

import './style.scss';

const NodeMetadata = ({ icon, displayType, theme, created }) => {

  const articleTypes = [
    'blog',
    'nieuwsbericht',
    'interview',
  ];

  return (
    <div className="NodeMetadata">
      <div className="NodeMetadata__wrapper">
        {theme && (
          <ThemeHeader theme={theme} />
        )}
        <div className="NodeMetadata__items">
          {displayType && icon && (
            <>
              <div className="NodeMetadata__items__item NodeMetadata__type">
                <i className={`icon icon-before ${icon}`} />
                {displayType}
              </div>
              {created && articleTypes.includes(displayType.toLowerCase()) && (
                <div className="NodeMetadata__items__item NodeMetadata__date">
                  <i className="icon icon-before icon-calendar" />
                  {`${created.getDate()}-${created.getMonth() + 1}-${created.getFullYear()}`}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default NodeMetadata;
